/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_Marketing_LabelInputs */

const en_consent_marketing_label = /** @type {(inputs: Consent_Marketing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I'd like to receive helpful tips, product updates, and offers via email.`)
};

const de_consent_marketing_label = /** @type {(inputs: Consent_Marketing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich moechte nuetzliche Tipps, Produktneuheiten und Angebote per E-Mail erhalten.`)
};

const fr_consent_marketing_label = /** @type {(inputs: Consent_Marketing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je souhaite recevoir des conseils utiles, des nouveautes et des offres par e-mail.`)
};

const es_consent_marketing_label = /** @type {(inputs: Consent_Marketing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Me gustaria recibir consejos utiles, novedades del producto y ofertas por correo electronico.`)
};

const it_consent_marketing_label = /** @type {(inputs: Consent_Marketing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorrei ricevere consigli utili, aggiornamenti sul prodotto e offerte via e-mail.`)
};

const nl_consent_marketing_label = /** @type {(inputs: Consent_Marketing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ik ontvang graag nuttige tips, productnieuws en aanbiedingen per e-mail.`)
};

const pl_consent_marketing_label = /** @type {(inputs: Consent_Marketing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chce otrzymywac przydatne wskazowki, nowosci produktowe i oferty droga elektroniczna.`)
};

const fi_consent_marketing_label = /** @type {(inputs: Consent_Marketing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haluan vastaanottaa hyodyllisia vinkkeja, tuoteuutisia ja tarjouksia sahkopostitse.`)
};

const da_consent_marketing_label = /** @type {(inputs: Consent_Marketing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeg vil gerne modtage nyttige tips, produktnyheder og tilbud via e-mail.`)
};

const sv_consent_marketing_label = /** @type {(inputs: Consent_Marketing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jag vill garna fa tips, produktnyheter och erbjudanden via e-post.`)
};

/**
* | output |
* | --- |
* | "I'd like to receive helpful tips, product updates, and offers via email." |
*
* @param {Consent_Marketing_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consent_marketing_label = /** @type {((inputs?: Consent_Marketing_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Marketing_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consent_marketing_label(inputs)
	if (locale === "fr") return fr_consent_marketing_label(inputs)
	if (locale === "es") return es_consent_marketing_label(inputs)
	if (locale === "it") return it_consent_marketing_label(inputs)
	if (locale === "nl") return nl_consent_marketing_label(inputs)
	if (locale === "pl") return pl_consent_marketing_label(inputs)
	if (locale === "fi") return fi_consent_marketing_label(inputs)
	if (locale === "da") return da_consent_marketing_label(inputs)
	if (locale === "sv") return sv_consent_marketing_label(inputs)
	return en_consent_marketing_label(inputs)
});